import LoginVue from '@/views/login/login.vue';

const basePath = '/login';

export const LOGIN_INDEX = 'login';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: LoginVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: LOGIN_INDEX,
      component: () => import(
        /* webpackChunkName: "login" */
        '@/views/login/index.vue'
      ),
      meta: { requiresAuth: true }
    }
  ]
};
